import BaseService from '../../base/base_service';
import Device from '../../utils/device/device';


import INetEntService, {
    NetEntLaunchGameRequest,
    NetEntLaunchGameResponse,
    NetEntSdk,
    NetEntConfig
} from './netent_service_interface';
import NetEntExtend from './netent_extend';


interface NetEntServiceParams {
    staticServerUrlTemplate: string;
    liveCasinoHostTemplate: string;
}

export default class NetEntService extends BaseService implements INetEntService {
    static CLASS = 'NetEntService';

    private _params: NetEntServiceParams;

    init(params: NetEntServiceParams) {
        super.init(params);
        this._params = params;
    }

    launchGame(request: NetEntLaunchGameRequest): Promise<NetEntLaunchGameResponse> {
        return this._loadNetEntSdk(request).then(netEntSdk => {
            return new Promise<NetEntLaunchGameResponse>((resolve, reject) => {
               const successFunc = (netEntExtendObj: any) => {
                   resolve({
                       netEntExtend: NetEntExtend.create({netEntExtendObject: netEntExtendObj})
                   });
               };

               const errorFunc = (err: any) => {
                   reject(err);
               };

               try {
                   this._createNetEntLaunchGameConfig(request)
                       .then(config => {
                           this.logger.debug(`Launching NetEnt game ${request.gameType} with the following params: ${JSON.stringify(config)}`);
                           netEntSdk.launch(config, successFunc, errorFunc);
                       }).catch(err => reject(err));
               } catch (ex) {
                   reject(ex);
               }
            });
        });
    }

    private _createNetEntLaunchGameConfig(request: NetEntLaunchGameRequest): Promise<NetEntConfig> {
        let config = {
            gameId: request.netEntGameType,
            sessionId: request.gameSessionId,
            language: request.language,
            staticServerURL: this._buildStaticServerUrl(request),
            gameServerURL: request.gameServerUrl,
            walletMode: 'seamlesswallet',
            width: '100%',
            height: '100%',
            enforceRatio: false,
        };
        if (Device.os.isMobileOS) {
            config = Object.assign(config, {
                launchType: 'iframe',
                lobbyURL: '#',
                depositAvailable: true
            });
        }
        if(Device.hybrid.isHybrid)
        {
            config = Object.assign(config, {disableDeviceDetection: true});
        }
        return Promise.resolve(config);
    }

    private _getSdkFromWindow(): NetEntSdk {
        return this.serviceFactory.windowService().getGlobalProperty('netent') as NetEntSdk;
    }

    private _loadNetEntSdk(request: NetEntLaunchGameRequest): Promise<NetEntSdk> {
        const sdk = this._getSdkFromWindow();
        if(sdk) {
            return Promise.resolve(sdk);
        } else {
            let sdkUrl = this._buildStaticServerUrl(request);
            if(!sdkUrl.endsWith('/')) {
                sdkUrl += '/';
            }
            sdkUrl += 'gameinclusion/library/gameinclusion.js?anticacheKey=' + this.serviceFactory.timeService().now();
            return this.serviceFactory.scriptLoaderService().loadScript({
                url: sdkUrl,
                tagId: 'netentsdk'
            }).then(() => this._getSdkFromWindow());
        }
    }

    private _buildStaticServerUrl(request: NetEntLaunchGameRequest): string {
        return this.serviceFactory.hybridService().prepareGameUrl(request.gameType, this._params.staticServerUrlTemplate.replace('{casinoid}', this._getCasinoId(request)));
    }

    private _getCasinoId(request: NetEntLaunchGameRequest): string {
        if (request.casinoId) {
            return request.casinoId;
        }

        throw new Error(`No casinoId specified in NetEntLaunchGameRequest ${JSON.stringify(request)}!`);
   }
}
